import { useEffect } from "react";

/**
 * Set per-page <title>, meta description, canonical URL and OG tags
 * on route change. Restores the site-wide defaults on unmount.
 */
export function usePageMeta({ title, description, path }) {
  useEffect(() => {
    const SITE = "Neurological Communication Partners";
    const fullTitle = title ? `${title} | ${SITE}` : SITE;
    const origin =
      typeof window !== "undefined" ? window.location.origin : "";
    const url = path ? `${origin}${path}` : origin;

    const prevTitle = document.title;
    document.title = fullTitle;

    const updateMeta = (selector, attr, value) => {
      if (!value) return null;
      const el = document.querySelector(selector);
      const prev = el?.getAttribute(attr);
      if (el) el.setAttribute(attr, value);
      return { el, attr, prev };
    };

    const revert = [
      updateMeta('meta[name="description"]', "content", description),
      updateMeta('meta[property="og:title"]', "content", fullTitle),
      updateMeta('meta[property="og:description"]', "content", description),
      updateMeta('meta[property="og:url"]', "content", url),
      updateMeta('meta[name="twitter:title"]', "content", fullTitle),
      updateMeta('meta[name="twitter:description"]', "content", description),
      updateMeta('link[rel="canonical"]', "href", url),
    ];

    return () => {
      document.title = prevTitle;
      revert.forEach((r) => {
        if (r?.el && r.prev != null) r.el.setAttribute(r.attr, r.prev);
      });
    };
  }, [title, description, path]);
}
